//
export default [
    {
        text: 'id',
        value: 'id',
    },
    {
        text: 'proveedor',
        value: 'pch_provider_business_name',
    },
    {
        text: 'solicitante',
        value: 'originator_user_name',
    },
    {
        text: 'Observación',
        value: 'observation',
    },
    {
        text: 'estado',
        value: 'pch_order_state_name',
    },
]
